import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import sale from "../../assets/images/banner/sale.jpeg"; // Ensure the path is correct

// Reusable Image Component
const Image = ({ imgSrc, style }) => {
  return <img src={imgSrc} alt="Banner" style={style} />;
};

const Banner2 = () => {
  const navigate = useNavigate(); // Hook for navigation

  const handleBannerClick = () => {
    const message = "Sale Is Live On Sunglasses";
    const key = 'ca_id';
    const value = 2;
    const table = 'getallproduct';
    // Pass the message to ShowMoreComponent via state
    navigate('/prodList', { state: { message, key,value,table} });
  };

  const imageStyle = {
    width: "100%",       // Ensures full width
    height: "auto",      // Maintains aspect ratio by adjusting height automatically
    objectFit: "contain",// Ensures the full image is visible without cutting off
    display: "block",    // Makes the image behave like a block-level element
    cursor: "pointer",   // Add cursor pointer for better UX
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "auto", // Allow the container height to adjust based on the image aspect ratio
    overflow: "hidden", // Prevents the container from spilling over
  };

  return (
    <div>
      {/* Banner Section */}
      <div style={containerStyle} onClick={handleBannerClick}>
        {/* Image Component */}
        <Image imgSrc={sale} style={imageStyle} />
      </div>

      {/* Divider Section */}
      <div className="px-4">
        <div className="flex items-center justify-center my-6">
          <div className="w-full border-t border-gray-300"></div>
          <span className="mx-4 text-black text-sm md:text-base font-semibold whitespace-nowrap">
          SALE IS LIVE
          </span>
          <div className="w-full border-t border-gray-300"></div>
        </div>
      </div>
    </div>
  );
};

export default Banner2;
